import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/Marquee";
import Businesses from "@/components/landing/Businesses";
import About from "@/components/landing/About";
import Foundation from "@/components/landing/Foundation";
import Consumers from "@/components/landing/Consumers";
import Gallery from "@/components/landing/Gallery";
import Expansion from "@/components/landing/Expansion";
import Footer from "@/components/landing/Footer";
import CustomerStoreDialog from "@/components/landing/CustomerStoreDialog";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Consumers />
      <Businesses />
      <About />
      <Foundation />
      <Gallery />
      <Expansion />
      <Footer />
      <CustomerStoreDialog />
    </main>
  );
}
